import { connect } from 'react-redux'
import MaintenanceAuditAppendComponent from '../components/MaintenanceAuditAppendComponent.jsx';
import {
	clean,
	forwardToFindAuditableMCards,
	forwardToSortAuditableMaintenanceCards,
	forwardToAssignAuditingCardTarget
} from '../actions';

const mapStateToProps = (state) => ({

	request: state.getIn(['maintenanceAuditingReducer', 'request']),
	response: state.getIn(['maintenanceAuditingReducer', 'response']),
	options: state.getIn(['maintenanceAuditingReducer', 'options']),
	
})

const mapDispatchToProps = (dispatch) => ({

	findAuditableMCards: (casePk) => {
        dispatch(forwardToFindAuditableMCards(casePk));
        clean(dispatch);
	},
	
	sortCards:( cards, order) =>{
		dispatch(forwardToSortAuditableMaintenanceCards(cards, order));
        clean(dispatch);
	},
    
	assignAppendTarget: (card, appendType) =>{
		let editing = {
			card: card,
			type: appendType
		}
		dispatch(forwardToAssignAuditingCardTarget(editing, appendType));
		clean(dispatch);
	}
})

const MaintenanceAuditAppendContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceAuditAppendComponent)

export default MaintenanceAuditAppendContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceAuditAppendContainer.jsx